import { Statuses, CompletedStatuses } from 'app/config/constants';

export const isComplete = (visit: any) => CompletedStatuses.includes(visit.status);

export const isEveryPhotoComplete = (photos: any) =>
  photos
    .filter((p: any) => p.required)
    .every((photo: any) => [Statuses.Approved, Statuses.Uploaded].includes(photo.status));
